"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

/**
 * экранирует строку для использования в регулярном шаблоне
 * @param {string} string
 * @return {string}
 */
function _default(string) {
  string = string || '';
  return string.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}